import { catalogEntry, type AppManifest } from '@infinix/registry';

/**
 * My account: personal settings for every signed-in person (Google Account / Microsoft My account). Notifications and
 * Regional wait on Core's notification and profile APIs: off the menu until they work (Account product review 2.3);
 * their pages still answer "Coming soon" for old links.
 */
export const accountManifest: AppManifest = {
  ...catalogEntry('account'),
  nav: [
    {
      items: [
        { label: 'Profile', path: '/account', icon: 'profile' },
        { label: 'Sign-in and security', path: '/account/security', icon: 'security' },
      ],
    },
  ],
};
